import Colors from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const HeroLegacyTheme = {
    heroSectionLegacy: {
        light: {
            backgroundColor: Colors.white,
            margin: {
                mobile: `${Spacings.xxLarge} 0`,
                tablet: `${Spacings.xLarge} 0`,
                desktop: `${Spacings.xxxxLarge} 0`,
            },
        },
        dark: { backgroundColor: Colors.black },
    },
};
export default HeroLegacyTheme;
